import React from 'react'

import { Dialog } from '@it-incubator/ui-kit'

import style from './ConfirmModal.module.css'

import { useKeyDown } from 'common/hooks'

type PropsType = {
  title: string
  isOpen: boolean
  message: string
  onClose: () => void
  callback: () => void
}

export const ConfirmModal = ({ title, isOpen, onClose, message, callback }: PropsType) => {
  const confirmButtonHandler = () => {
    if (isOpen) {
      callback()
    }

    onClose()
  }

  useKeyDown(confirmButtonHandler, 'Enter', [isOpen])

  return (
    <Dialog
      title={title}
      open={isOpen}
      onClose={onClose}
      onConfirmButtonClick={confirmButtonHandler}
      onCancelButtonClick={onClose}
      confirmButtonText="Да"
      cancelButtonText="Нет"
    >
      <p className={style.message}>{message}</p>
    </Dialog>
  )
}
